interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
  className?: string
  textColor?: 'default' | 'white'
}

export const Logo = ({ size = 'md', showText = true, className = '', textColor = 'default' }: LogoProps) => {
  const sizes = {
    sm: { icon: 24, text: 'text-lg' },
    md: { icon: 32, text: 'text-2xl' },
    lg: { icon: 48, text: 'text-3xl' },
  }
  
  const currentSize = sizes[size]

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src="/assets/logo/logo.svg" 
        alt="Projetoize Logo" 
        className="flex-shrink-0"
        width={currentSize.icon}
        height={currentSize.icon}
      />
      {showText && (
        <h1 className={`${currentSize.text} font-bold`}>
          <span className={textColor === 'white' ? 'text-blue-400' : 'text-blue-600'}>PROJETO</span>
          <span className={textColor === 'white' ? 'text-orange-400' : 'text-orange-500'}>IZE</span>
        </h1>
      )}
    </div>
  )
}

